import { useCreationStore } from '../../lib/creationStore'

const ATTRS = [
  { key: 'attr_str', label: 'STR (Strength)' },
  { key: 'attr_sta', label: 'STA (Stamina)' },
  { key: 'attr_dex', label: 'DEX (Dexterity)' },
  { key: 'attr_agl', label: 'AGL (Agility)' },
  { key: 'attr_eye', label: 'EYE (Eyesight)' },
  { key: 'attr_hrg', label: 'HRG (Hearing)' },
  { key: 'attr_sml', label: 'SML (Smell)' },
  { key: 'attr_voi', label: 'VOI (Voice)' },
  { key: 'attr_int', label: 'INT (Intelligence)' },
  { key: 'attr_aur', label: 'AUR (Aura)' },
  { key: 'attr_wil', label: 'WIL (Will)' },
] as const

type AttrKey = typeof ATTRS[number]['key']

export function StepAttributes() {
  const store = useCreationStore()

  return (
    <div>
      <h3>Step 4: Attributes</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
        {ATTRS.map(a => (
          <div key={a.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <label style={{ fontSize: '0.9rem' }}>{a.label}</label>
            <input
              type="number" min={1} max={25}
              value={store[a.key as AttrKey]}
              onChange={e => store.setField(a.key as AttrKey, parseInt(e.target.value) || 1)}
              style={{ width: 60, padding: '0.3rem', textAlign: 'center' }}
            />
          </div>
        ))}
      </div>
      <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <label style={{ fontSize: '0.9rem' }}>Morality (3–18)</label>
        <input
          type="number" min={3} max={18}
          value={store.morality}
          onChange={e => store.setField('morality', parseInt(e.target.value) || 10)}
          style={{ width: 60, padding: '0.3rem', textAlign: 'center' }}
        />
      </div>
    </div>
  )
}
